export default __webpack_public_path__ + "static/video_abloop-dfc0d38c9dd9efc5c9ca1c919f86d316.mp4";